import React, { useState } from "react";
import axios from "axios";
import {
  Alert,
  CircularProgress,
  Card,
  CardContent,
  Typography,
  Snackbar,
  Stack,
  InputAdornment,
  IconButton,
  Icon
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import SendIcon from "@mui/icons-material/Send";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

const API_BASE = "https://surveys.exchange-ip.com/api";

function SendInviteEmail() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleSendInvite = async () => {
    setAlert({ type: "", message: "" });

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setAlert({ type: "error", message: "Please enter a valid email address." });
      setShowSnackbar(true);
      return;
    }

    try {
      setSending(true);
      const res = await axios.post(`${API_BASE}/send-link`, { email });

      if (res.data.success) {
        setAlert({
          type: "success",
          message: res.data.message || "Invitation sent successfully!",
        });
        setEmail("");
      } else {
        throw new Error(res.data.message || "Failed to send invitation.");
      }
    } catch (err) {
      setAlert({
        type: "error",
        message:
          err.response?.data?.message || err.message || "Error sending invitation.",
      });
    } finally {
      setSending(false);
      setShowSnackbar(true);
    }
  };

  return (
    <SoftBox>
      {/* <Card elevation={3}> */}
      <CardContent>
        <Typography variant="h5" gutterBottom>
          📧 Send Invitation Email
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Enter the email address of the user you want to invite. They will receive a link to join.
        </Typography>

        <Stack direction="row" spacing={2} mt={2} mb={2}>
          <SoftInput
            type="email"
            label="User Email"
            placeholder="user@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon color="action" />
                </InputAdornment>
              ),
            }}
          />

          <SoftButton
            variant="gradient"
            color="info"
            onClick={handleSendInvite}
            disabled={sending || !email}
            startIcon={!sending && <SendIcon />}
            fullWidth
            sx={{ minWidth: 160 }}
          >
            {sending ? <CircularProgress size={20} color="inherit" /> : "Send Invite"}
          </SoftButton>


        </Stack>
        <SoftBox display="flex" alignItems="center" mt={2}>
          <Icon sx={{ color: "text.secondary", mr: 1, fontSize: 16 }}>info</Icon>
          <Typography variant="caption" color="text.secondary">
            Only authorized emails will be able to register with the sent link.
          </Typography>
        </SoftBox>

        <Snackbar
          open={showSnackbar}
          autoHideDuration={4000}
          onClose={() => setShowSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {alert.message && (
            <Alert severity={alert.type} onClose={() => setShowSnackbar(false)} variant="filled">
              {alert.message}
            </Alert>
          )}
        </Snackbar>
      </CardContent>
      {/* </Card> */}
    </SoftBox>
  );
}

export default SendInviteEmail;
